export default {"src":"/_next/static/media/configure-company.969374ac.svg","height":57,"width":87};